export default "__VITE_ASSET__114f8e23__"